module.exports = __webpack_public_path__ + "img/dots-menu.34f3f57e.svg";